function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Messaging } from 'oskari-ui/util';
import { VectorStyle, RUNTIME_PREFIX } from '../../mapmodule/domain/VectorStyle';
import { BUNDLE_KEY } from '../constants';
export var UserStyleService = /*#__PURE__*/function () {
  function UserStyleService(sandbox) {
    _classCallCheck(this, UserStyleService);
    this.styles = []; // server VectorStyle
    this.sandbox = sandbox;
    this.log = Oskari.log('UserStyleService');
    Oskari.makeObservable(this);
    this.fetchUserStyles();
  }
  return _createClass(UserStyleService, [{
    key: "saveUserStyle",
    value: function saveUserStyle(style) {
      if (!style.name) {
        var nextVal = Oskari.getSeq(BUNDLE_KEY).nextVal();
        style.name = Oskari.getMsg(BUNDLE_KEY, 'defaultName') + ' ' + nextVal;
      }
      if (Oskari.user().isLoggedIn()) {
        if (style.id) {
          this.updateStyle(style);
        } else {
          this.saveStyle(style);
        }
      } else {
        this.storeStyle(style);
      }
    }
  }, {
    key: "removeUserStyle",
    value: function removeUserStyle(id) {
      if (Oskari.user().isLoggedIn()) {
        this.deleteStyle(id);
      } else {
        this.removeFromStore(id);
      }
    }
  }, {
    key: "storeStyle",
    value: function storeStyle(style) {
      var id = style.id,
        layerId = style.layerId;
      if (!layerId) {
        this.log.warn('Tried to store vector style without layerId. Skipping.');
        return;
      }
      // new runtime styles for guest user doesn't have id
      // use string prefixed time to get unique id and mark as runtime style
      // backend stored styles have always number (Long) id
      if (!id) {
        style.id = RUNTIME_PREFIX + Date.now().toString();
      }
      var index = this.styles.findIndex(function (s) {
        return s.id === id;
      });
      if (index !== -1) {
        this.styles[index] = style;
      } else {
        this.styles.push(style);
      }
      this.applyStyleToLayer(style);
      this.notifyStyleUpdate(layerId);
    }
  }, {
    key: "removeFromStore",
    value: function removeFromStore(id) {
      var style = this.getStyleById(id);
      if (!style) {
        this.log.warn("Tried to remove vector style: ".concat(id, " from storage. Style does not exist. Skipping."));
        return;
      }
      this.styles = this.styles.filter(function (s) {
        return s.id !== id;
      });
      this.removeStyleFromLayer(style);
      this.notifyStyleUpdate(style.layerId);
    }

    // Used for listing all styles in mydata tab
  }, {
    key: "fetchUserStyles",
    value: function fetchUserStyles() {
      var _this = this;
      if (!Oskari.user().isLoggedIn()) {
        return;
      }
      this.ajaxStarted();
      fetch(Oskari.urls.getRoute('VectorStyle'), {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          return Promise.reject(new Error('Fetching user vector styles failed'));
        }
        return response.json();
      }).then(function (json) {
        _this.handleFetchResponse(json);
      }).catch(function (error) {
        return _this.ajaxError('fetch', error);
      });
    }
  }, {
    key: "deleteStyle",
    value: function deleteStyle(id) {
      var _this2 = this;
      this.ajaxStarted();
      fetch(Oskari.urls.getRoute('VectorStyle', {
        id: id
      }), {
        method: 'DELETE'
      }).then(function (response) {
        return response.ok && response;
      }).then(function (resp) {
        if (resp === false) {
          throw Error('Failed to delete vector style');
        }
        _this2.removeFromStore(id);
        _this2.ajaxSuccess('delete');
      }).catch(function (error) {
        return _this2.ajaxError('delete', error);
      });
    }
  }, {
    key: "saveStyle",
    value: function saveStyle(style) {
      var _this3 = this;
      this.ajaxStarted();
      fetch(Oskari.urls.getRoute('VectorStyle'), {
        method: 'POST',
        body: JSON.stringify(style)
      }).then(function (response) {
        if (!response.ok) {
          return Promise.reject(new Error('Failed to save vector style'));
        }
        return response.json();
      }).then(function (json) {
        _this3.storeStyle(json);
        _this3.ajaxSuccess('save');
      }).catch(function (error) {
        return _this3.ajaxError('save', error);
      });
    }
  }, {
    key: "updateStyle",
    value: function updateStyle(style) {
      var _this4 = this;
      this.ajaxStarted();
      fetch(Oskari.urls.getRoute('VectorStyle'), {
        method: 'PUT',
        body: JSON.stringify(style)
      }).then(function (response) {
        if (!response.ok) {
          return Promise.reject(new Error('Failed to update vector style'));
        }
        return response.json();
      }).then(function (json) {
        _this4.storeStyle(json);
        _this4.ajaxSuccess('save');
      }).catch(function (error) {
        return _this4.ajaxError('save', error);
      });
    }
  }, {
    key: "ajaxStarted",
    value: function ajaxStarted() {
      this.trigger('ajax', true);
    }
  }, {
    key: "ajaxError",
    value: function ajaxError(method, error) {
      Messaging.error(Oskari.getMsg(BUNDLE_KEY, "error.".concat(method)));
      this.log.error(error);
      this.trigger('ajax', false);
    }
  }, {
    key: "ajaxSuccess",
    value: function ajaxSuccess(method) {
      Messaging.success(Oskari.getMsg(BUNDLE_KEY, "success.".concat(method)));
      this.trigger('ajax', false);
    }
  }, {
    key: "handleFetchResponse",
    value: function handleFetchResponse(json) {
      if (!Array.isArray(json)) {
        return;
      }
      this.styles = json;
      // Don't apply styles for layers. Only notify mass update.
      this.notifyStyleUpdate();
    }
  }, {
    key: "notifyStyleUpdate",
    value: function notifyStyleUpdate(layerId) {
      this.trigger('update', layerId);
    }
  }, {
    key: "notifyLayerUpdate",
    value: function notifyLayerUpdate(layerId) {
      var event = Oskari.eventBuilder('MapLayerEvent')(layerId, 'update');
      this.sandbox.notifyAll(event);
    }
  }, {
    key: "getQName",
    value: function getQName() {
      return 'Oskari.mapframework.userstyle.service.UserStyleService';
    }
  }, {
    key: "_getStyleName",
    value: function _getStyleName(style) {
      // id is used for VectorStyle name (string)
      return style === null || style === void 0 ? void 0 : style.id.toString();
    }
  }, {
    key: "getStyleNamesForLayer",
    value: function getStyleNamesForLayer(layerId) {
      var _this5 = this;
      return this.getStylesByLayer(layerId).map(function (style) {
        return _this5._getStyleName(style);
      });
    }
  }, {
    key: "applyStyleToLayer",
    value: function applyStyleToLayer(style) {
      var _ref = style || {},
        layerId = _ref.layerId;
      // Users own styles are loaded (overrides) via DescribeLayer when layer is added first time on the map
      // Find layer from all available to be sure that style is added to layer
      // Note that style is selected only when layer is on the map (is selected)
      var layer = this.sandbox.findMapLayerFromAllAvailable(layerId);
      if (layer) {
        layer.addStyle(new VectorStyle(style));
        var name = this._getStyleName(style);
        layer.selectStyle(name);
        // request notifies change if layer is selected
        this.sandbox.postRequestByName('ChangeMapLayerStyleRequest', [layerId, name]);
        this.notifyLayerUpdate(layerId);
      }
    }
  }, {
    key: "removeStyleFromLayer",
    value: function removeStyleFromLayer(style) {
      var _ref2 = style || {},
        layerId = _ref2.layerId;
      var layer = this.sandbox.findMapLayerFromAllAvailable(layerId);
      if (layer) {
        var name = this._getStyleName(style);
        layer.removeStyle(name);
        this.notifyLayerUpdate(layerId);
      }
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      return this.styles;
    }
  }, {
    key: "getStylesByLayer",
    value: function getStylesByLayer(layerId) {
      return this.styles.filter(function (s) {
        return s.layerId === layerId;
      });
    }
  }, {
    key: "getStyleById",
    value: function getStyleById(id) {
      return this.styles.find(function (s) {
        return s.id === id;
      });
    }
  }]);
}();